import {initWebComponent} from "@/helpers/web-component-helper";
import {
    getBySelector,
    getValueBySelector, hideElementsBySelector,
    removeClassBySelector,
    showElementsBySelector
} from "@/helpers/element-helper";
import WMSCapabilities from 'ol/format/WMSCapabilities.js';
import {addTemporaryLayer} from "@/helpers/layer/temporary/temporary-layer-helper";
import {WMTSCapabilities} from "ol/format";
import {startLadda, stopLadda} from "@/helpers/ladda-helper";
import {getWmtsUrl} from "@/modules/ol/service/ol-service-wmts.js";

let layerCapabilities = []
let capabilities

export class BookmarkDataSetWebserviceComponent extends HTMLElement {
    constructor(){
        super();

        const template = document.createElement('template');
        template.innerHTML = `

         <div class="card-body p-2"">
            <div class="mt-1">
                <div class="btn-group btn-group-toggle bg-light p-1 d-flex" data-toggle="buttons">
                    <label data-type="WMS" class="btn btn-data-set-web-service btn-default btn-tools btn-sm md-btn-flat waves-effect active">
                        WMS
                    </label>
                    <label data-type="WFS" class="btn btn-data-set-web-service btn-default btn-tools btn-sm md-btn-flat waves-effect">
                        WFS
                    </label>
                    <label data-type="WMTS"  class="btn btn-data-set-web-service btn-default btn-tools btn-sm md-btn-flat waves-effect">
                        WMTS
                    </label>
                    <label data-type="XYZ" class="btn btn-data-set-web-service btn-default btn-tools btn-sm md-btn-flat waves-effect">
                        XYZ
                    </label>
                    <label data-type="3DTileSet" class="btn btn-data-set-web-service btn-default btn-tools btn-sm md-btn-flat waves-effect">
                        3D Tile Set
                    </label>
                    <label data-type="ArcGISMapServer" class="btn btn-data-set-web-service btn-default btn-tools btn-sm md-btn-flat waves-effect">
                        ArcGIS MapServer
                    </label>
                </div>
            </div>
        </div>
 
         <div class="card-body p-2">
            <div class="form-group">
             <label class="form-label">Url</label>
              <input type="text" class="form-control" id="iptServiceUrl" value="" placeholder="https://url/geoserver/wms?">
              <small class="invalid-feedback" id="spnServiceUrl"></small>
            </div> 
            <div class="form-group mt-2">
                <button id="btnLoadService" data-spinner-color="#858380"  class="btn btn-outline-secondary btn-block btn-sm ladda-button">Service laden</a>
            </div>
            <div class="d-none" id="divAddTemporaryLayer">
                <div class="form-group" id="divAddTemporaryLayerSelect">
                 <label class="form-label">Kies laag:</label>
                  <select class="custom-select" id="slcServiceLayer">
                  </select>
                </div> 
                <div class="form-group" id="divAddTemporaryLayerName">
                 <label class="form-label">Naam:</label>
                  <input type="text" class="form-control" id="iptServiceLayerName">
                </div> 
                <div class="form-group mt-2">
                    <button id="btnAddTemporaryLayer" data-spinner-color="#858380" class="btn btn-outline-secondary btn-block btn-sm ladda-buttono">Toevoegen</a>
                </div>
            </div>
         </div>
`
        initWebComponent(this, template)

        let activeServiceType = 'WMS'

        hideElementsBySelector('#divAddTemporaryLayerName')
        this.addEventListener('click', (evt) => {
            if(evt.target.dataset.type) {
                getBySelector('#iptServiceUrl').classList.remove('is-invalid')
                removeClassBySelector('.btn-data-set-web-service', 'active')
                evt.target.classList.add('active')


                hideElementsBySelector('#divAddTemporaryLayerSelect')
                hideElementsBySelector('#divAddTemporaryLayerName')

                activeServiceType = evt.target.dataset.type
                getBySelector('#iptServiceUrl').value = ''
                let placeHolder = ''
                switch (activeServiceType) {
                    case 'WMS':
                        placeHolder = 'https://url/geoserver/wms?'
                        showElementsBySelector('#divAddTemporaryLayerSelect')
                        break;
                    case 'WFS':
                        placeHolder = 'https://url/geoserver/wfs?'
                        showElementsBySelector('#divAddTemporaryLayerSelect')
                        break;
                    case 'WMTS':
                        placeHolder = 'https://url/tiles/service/wtms/'
                        showElementsBySelector('#divAddTemporaryLayerSelect')
                        break;
                    case 'XYZ':
                        placeHolder = 'https://url/{z}/{x}/{y}@2x.png'
                        showElementsBySelector('#divAddTemporaryLayerName')
                        break;
                    case '3DTileSet':
                        placeHolder = 'https://url/tileset.json?'
                        showElementsBySelector('#divAddTemporaryLayerName')
                        break;
                    case 'ArcGISMapServer':
                        placeHolder = 'https://url/arcgis/rest/services/servicenaam'
                        showElementsBySelector('#divAddTemporaryLayerSelect')
                        break;
                }
                getBySelector('#iptServiceUrl').placeholder = placeHolder
                hideElementsBySelector('#divAddTemporaryLayer')
            }
        })

        getBySelector('#btnLoadService').addEventListener('click', (evt) => {
            const service = {}
            service.Url = getValueBySelector('#iptServiceUrl')
            service.Type = activeServiceType

            startLadda('#btnLoadService')

            hideElementsBySelector('#divAddTemporaryLayer')

            getBySelector('#iptServiceUrl').classList.remove('is-invalid')
            let url
            let parser
            switch (service.Type) {
                case 'WMS':
                case 'WFS':
                    parser = new WMSCapabilities();

                    url = service.Url.replace('wfs', 'wms')
                    if(!url.includes('?')) {
                        url += '?'
                    }
                    if(!url.includes('service=')) {
                        url += 'service=WMS'
                    }
                    if(!url.includes('request=')) {
                        url += '&request=GetCapabilities'
                    }

                    fetch(url).then(response => {

                        // console.log(response)

                        if(response.status === 404) {
                            errorNotFound()
                            return ''
                        }
                        return response.text();
                    }).then(result => {

                        if(result === '') {
                            return
                        }

                        layerCapabilities = []
                        result = parser.read(result);

                        const layers = result.Capability.Layer.Layer
                        if(layers.length > 0) {
                            let options = ''
                            layers.map( layer => {
                                layerCapabilities.push(layer)
                                options += '<option value="' + layer.Name +'">' + layer.Title + '</option>'
                            })
                            getBySelector('#slcServiceLayer').innerHTML = options
                        }
                        showElementsBySelector('#divAddTemporaryLayer')
                        stopLadda()
                    }).catch(() => {
                        errorCors()
                    })
                    break;
                case 'WMTS':
                    url = getWmtsUrl(service.Url)
                    parser = new WMTSCapabilities();

                    fetch(url).then(response => {
                        if(response.status === 404) {
                            errorNotFound()
                            return
                        }

                        return response.text();
                    }).then(result => {

                        layerCapabilities = []
                        result = parser.read(result);
                        capabilities = result
                        //// console.log(result)
                        const layers = result.Contents.Layer
                        if(layers.length > 0) {
                            let options = ''
                            layers.map( layer => {
                                layerCapabilities.push(layer)

                                // console.log(layer)

                                options += '<option value="' + layer.Identifier +'">' + layer.Title + '</option>'
                            })
                            getBySelector('#slcServiceLayer').innerHTML = options
                        }
                        showElementsBySelector('#divAddTemporaryLayer')
                        stopLadda()
                    }).catch(error => {
                        errorCors()
                    })
                    break;
                case 'ArcGISMapServer':
                    url = service.Url
                    fetch(url + '?f=pjson').then(response => {
                        if(response.status === 404) {
                            errorNotFound()
                            return
                        }
                        return response.json();
                    }).then(result => {
                        let options = ''

                        result.services.map( service => {
                            let name = service.name.split('/')[1]
                            options += '<option value="' + name +'">' + name + '</option>'
                        })
                        getBySelector('#slcServiceLayer').innerHTML = options
                        showElementsBySelector('#divAddTemporaryLayer')
                        stopLadda()
                    }).catch(error => {
                        stopLadda()
                        errorCors()
                    })
                    break;
                default:
                    layerCapabilities = []
                    showElementsBySelector('#divAddTemporaryLayer')
                    stopLadda()
                    break;
            }
        })

        getBySelector('#btnAddTemporaryLayer').addEventListener('click', (evt) => {
            startLadda('#btnAddTemporaryLayer')
            let layerName = getValueBySelector('#slcServiceLayer')
            if(['XYZ', '3DTileSet'].includes(activeServiceType)) {
                layerName = getValueBySelector('#iptServiceLayerName')
            }

            addTemporaryLayer(activeServiceType, layerCapabilities, layerName, capabilities)
        })

        function errorNotFound() {
            getBySelector('#spnServiceUrl').innerHTML = 'Controleer het URL en probeer het nogmaals.'
            getBySelector('#iptServiceUrl').classList.add('is-invalid')
            stopLadda()
        }

        function errorCors() {
            getBySelector('#spnServiceUrl').innerHTML = 'CORS error: Neem contact met de beheerder van de service op om deze fout te herstellen.'
            getBySelector('#iptServiceUrl').classList.add('is-invalid')
            stopLadda()
        }
    }
}
